/**
 * Construct a full blob URL from relative path returned by Rails API
 * If URL is already absolute, returns as-is
 * If URL is relative, combines with base domain (without /api)
 */
export const getFullBlobUrl = (blobPath?: string): string | undefined => {
  if (!blobPath) return undefined;
  
  // If already absolute URL, return as-is
  if (blobPath.startsWith('http://') || blobPath.startsWith('https://')) {
    return blobPath;
  }
  
  // If relative path, combine with base domain (without /api prefix)
  if (blobPath.startsWith('/')) {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3300/api';
    // Remove /api from the end to get base URL
    const baseUrl = apiUrl.replace(/\/api\/?$/, '');
    return `${baseUrl}${blobPath}`;
  }
  
  return blobPath;
};
